<div class="grid inner-scroll" fusePerfectScrollbar>

  <div *ngFor="let creature of items" class="item">
    <app-gallery-thumbnail [creature]="creature" (click)="onClick(creature)"></app-gallery-thumbnail>
  </div>
</div>